'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const DateHelper = require('../../../../_plugins/lib/dateHelper')
const { string, bool } = PropTypes

const TimeSelect = createReactClass({
  propTypes: {
    activeTime: string,
    name: string,
    fullWidth: bool,
    pagename: string
  },

  getDefaultProps () {
    return {
      activeTime: '1200',
      fullWidth: false
    }
  },

  makeOptions () {
    const arr = Array.apply(null, { length: 48 }).map(Number.call, Number)
    return arr.filter(i => {
      return i
    }).map(i => {
      let val = parseInt(i / 2, 10)
      let padVal = DateHelper.pad(val * 100, 4)
      if ((i + 1) % 2 === 0) padVal = DateHelper.pad((val * 100) + 30, 4)
      const returnText = padVal.slice(0, 2) + ':' + padVal.slice(-2)
      return (<option key={i} value={padVal}>{returnText}</option>)
    })
  },

  render () {
    const { activeTime, name } = this.props
    const times = this.makeOptions()
    return (
      <select name={name} className='form-control' data-track-name={name} defaultValue={activeTime}>{times}</select>
    )
  }
})

module.exports = TimeSelect



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/engine-horizontal/times-dropdown.jsx